/**
 * Copies text, falling back to a selection-based copy where the Clipboard API
 * is denied (outside a secure context, and in some WebViews). Resolves false
 * if neither worked.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return copyViaSelection(text)
  }
}

/** execCommand is deprecated but is still the only fallback that works here. */
function copyViaSelection(text: string): boolean {
  try {
    const field = document.createElement('textarea')
    field.value = text
    field.setAttribute('readonly', '')
    field.style.position = 'fixed'
    field.style.opacity = '0'
    document.body.appendChild(field)
    field.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(field)
    return ok
  } catch {
    return false
  }
}
